function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'print-vertical': 'url("//creationsofchrist.com/cdn/shop/files/print-vertical_120x.png?v=17265908076749706893")','print-horizontal': 'url("//creationsofchrist.com/cdn/shop/files/print-horizontal_120x.png?v=18279282354625651949")','print-square': 'url("//creationsofchrist.com/cdn/shop/files/print-square_120x.png?v=11966986023921676041")','framed-vertical': 'url("//creationsofchrist.com/cdn/shop/files/framed-vertical-v2_120x.png?v=3683379011714584561")','framed-horizontal': 'url("//creationsofchrist.com/cdn/shop/files/framed-horizontal-v2_120x.png?v=11832526135002140108")','framed-square': 'url("//creationsofchrist.com/cdn/shop/files/framed-square-v2_120x.png?v=9837145507407235758")','unframed-vertical': 'url("//creationsofchrist.com/cdn/shop/files/unframed-vertical_120x.png?v=2199511629956049212")','unframed-horizontal': 'url("//creationsofchrist.com/cdn/shop/files/unframed-horizontal_120x.png?v=2864613648787210657")','unframed-square': 'url("//creationsofchrist.com/cdn/shop/files/unframed-square_120x.png?v=7940345513636232351")','unframed': 'url("//creationsofchrist.com/cdn/shop/files/unframed_120x.png?v=2216173682983277475")','blue-ink-vertical': 'url("//creationsofchrist.com/cdn/shop/files/framed-vertical-blue_120x.png?v=7547304442853803817")','blue-ink-horizontal': 'url("//creationsofchrist.com/cdn/shop/files/framed-horizontal-blue_120x.png?v=15778972059300613715")','sepia-ink-vertical': 'url("//creationsofchrist.com/cdn/shop/files/framed-vertical-sepia_120x.png?v=5015949164764959703")','sepia-ink-horizontal': 'url("//creationsofchrist.com/cdn/shop/files/framed-horizontal-sepai_120x.png?v=4865527896672557897")','oak': 'url("//creationsofchrist.com/cdn/shop/files/oak_120x.jpg?v=314752646904752967")','espresso': 'url("//creationsofchrist.com/cdn/shop/files/espresso_120x.jpg?v=10304619316624774266")','black': 'url("//creationsofchrist.com/cdn/shop/files/black_120x.jpg?v=11302557100878306688")','silver': 'url("//creationsofchrist.com/cdn/shop/files/silver_120x.jpg?v=3079092621216233525")','gold': 'url("//creationsofchrist.com/cdn/shop/files/gold_120x.jpg?v=739286200179999961")','white': 'url("//creationsofchrist.com/cdn/shop/files/white_120x.jpg?v=11309712190830666979")','natural-wood': 'url("//creationsofchrist.com/cdn/shop/files/NaturalWood_120x.png?v=1099826707973706480")','classic-oak': 'url("//creationsofchrist.com/cdn/shop/files/NaturalOak_120x.png?v=472045780546762061")','matte-black': 'url("//creationsofchrist.com/cdn/shop/files/MatteBlack_120x.png?v=1603050408139930350")','gallery-white': 'url("//creationsofchrist.com/cdn/shop/files/GalleryWhite_120x.png?v=5096607381547594978")','brushed-gold': 'url("//creationsofchrist.com/cdn/shop/files/BrushedGold_120x.png?v=13031619931820608149")',};

    this.triggers = ['frame color','type',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
